<template>
  <div class="choose">
    <ul>
      <li v-for="(item, index) of list" :key="index" @click="areaCodeClick(item)">
        <p>{{ item.country }}</p>
        <b>+{{ item.code }}</b>
      </li>
    </ul>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
const areaCodeList = require('../../assets/common/js/areaCode')
export default {
  name: 'chooseCountry',
  data() {
    return {
      list: []
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.list = areaCodeList
    if (isWeixin()) {
      fenxiang({ path: 'chooseCountry' })
    }
  },
  methods: {
    areaCodeClick: function (items) {
      if (this.$route.query.type === 'login') {
        this.$router.replace({
          path: '/login',
          query: {
            ...this.$route.query,
            area_code: items.code
          }
        })
      } else if (this.$route.query.type === 'inphone') {
        var obj
        if (this.$route.query.token) {
          obj = {
            area_code: items.code,
            pt: this.$route.query.pt,
            token: this.$route.query.token
          }
        } else {
          obj = {
            area_code: items.code
          }
        }
        this.$router.replace({ path: '/inphone', query: obj })
      } else if (this.$route.query.type === 'uptphone') {
        var obj
        if (this.$route.query.token) {
          obj = {
            area_code: items.code,
            pt: this.$route.query.pt,
            token: this.$route.query.token
          }
        } else {
          obj = {
            area_code: items.code
          }
        }
        this.$router.replace({ path: '/phone', query: obj })
      } else if (this.type === 'feedback') {
        this.$emit('on-area-code', items.code)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.choose {
  background: #fff;
  ul {
    li {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      padding: 0.12rem 0;
      margin: 0 0.11rem;
      border-bottom: 1px solid #efefef;
      p {
        font-size: 0.15rem;
        font-weight: 400;
        color: rgba(41, 41, 41, 1);
        line-height: 0.21rem;
      }
      b {
        display: block;
        font-size: 0.15rem;
        font-weight: 600;
        color: rgba(74, 144, 226, 1);
        line-height: 0.21rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/chooseCountry.vue